import { render, staticRenderFns } from "./gssRelationMange.vue?vue&type=template&id=48ef7dfc&scoped=true&"
import script from "./gssRelationMange.vue?vue&type=script&lang=js&"
export * from "./gssRelationMange.vue?vue&type=script&lang=js&"
import style0 from "./gssRelationMange.vue?vue&type=style&index=0&id=48ef7dfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ef7dfc",
  null
  
)

export default component.exports